export default __webpack_public_path__ + "static/0274-3320fb5a33585658b9ccafb1a88670c2.png";